export default {
  // 定义一个 getter
  isBinded: (state) => {
    return state.bindRoleInfo && state.bindRoleInfo.roleName
  }
}